var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 20.248,
    viewBox: "0 0 16.5 20.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_49_2",
    "data-name": "Component 49 \\u2013 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M11.54,22.351l.07.04.028.016a.76.76,0,0,0,.723,0l.028-.015.071-.041q.587-.348,1.144-.742a19.58,19.58,0,0,0,2.683-2.282A12.735,12.735,0,0,0,20.25,10.5a8.25,8.25,0,1,0-16.5,0,12.741,12.741,0,0,0,3.963,8.827A19.58,19.58,0,0,0,10.4,21.609q.557.394,1.145.742ZM12,13.5a3,3,0,1,0-3-3A3,3,0,0,0,12,13.5Z",
    transform: "translate(-3.75 -2.25)",
    fill: "#293139",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.edadf3b42b9ac4c6aac0df9134ca467e.svg";
export { ForwardRef as ReactComponent };